// @flow
import React from 'react';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { translate } from 'react-i18next';

const BaseButton = styled(Button)`
  margin: 0px 12px;
`;

const SButton = styled(BaseButton)`
  color: white;
  box-shadow: none;
`;

const SDialogActions = styled(DialogActions)`
  margin: 0px auto 24px;
`;

const Message = styled.div`
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.54);
`;

interface Props {
  action: string;
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  message?: string;
  t: any,
}

function ConfirmationDialog({ action, open, onCancel, onConfirm, message, t }: Props) {
  function stopPropagation(callback?: Function) {
    return (e) => {
      e.stopPropagation();
      callback && callback(e);
    };
  }

  return (
    <Dialog open={open} onClose={stopPropagation(onCancel)} onClick={stopPropagation()}>
      <DialogTitle align={'center'}>
        {t('confirmationPrompt', { action })}
      </DialogTitle>
      { message &&
        <DialogContent>
          <Message>
            {message}
          </Message>
        </DialogContent>
      }
      <SDialogActions>
        <BaseButton
          variant={'outlined'}
          onClick={stopPropagation(onCancel)}
          color="primary"
        >
          {t('cancel')}
        </BaseButton>
        <SButton
          onClick={stopPropagation(onConfirm)}
          color="primary"
          autoFocus
          variant={'contained'}
        >
          {t('confirm')}
        </SButton>
      </SDialogActions>
    </Dialog>
  );
}

export default translate()(ConfirmationDialog);



// WEBPACK FOOTER //
// ./src/common/components/ui/ConfirmationDialog.js